import { Injectable } from '@angular/core';
import {NavigationStart, Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private history: string[] = [];
  private ignoredRoutes: string[] = ['/imprint', '/data-privacy']; // Routes to be ignored
  constructor(private router: Router) {
    // Listen to Router navigation events to update history
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.updateHistory(event.url);
      }
    });
  }

  private updateHistory(url: string): void {
    if (this.history.length === 0 || this.history[this.history.length - 1] !== url) {
      this.history.push(url);
    }
  }

  public getHistory(): string[] {
    return this.history;
  }

  public navigateBack(): void {
    // if (this.history.length > 1) {
    //
    //   while (this.history.length > 1) {
    //     const lastRoute = this.history.pop(); // Remove the last route
    //     const previousRoute = this.history[this.history.length - 1]; // Peek at the new "last" route
    //
    //     if (!this.ignoredRoutes.includes(previousRoute as string)) {
    //       this.router.navigateByUrl(previousRoute as string);
    //       break;
    //     }
    //   }
    // } else {
    //   if (window.history.length > 1) {
    //     window.history.back(); // Use the browser's built-in history
    //   } else {
    //     // Optional fallback if even the browser history is insufficient
    //     this.router.navigate(['/']); // Navigate to the default route
    //   }
    // }
    window.history.back();
  }

}
